<template>
  <div>

    <div>
      <p class="font-bold">Organisationen</p>
      <ul>
        <li v-for="org in this.$store.state.organizations" class="list-none">
          <div class="border p-4">
            <p>
              <strong>{{ org.name }}</strong>
              <span class="inline-block rounded-full bg-black text-white ml-2 px-2"
                    v-if="org.admins.includes(user.uid)">Admin</span>
            </p>
            <div class="btn-gro hidden">
              <button class="btn btn-primary">Fragenbibliothek bearbeiten</button>
              <button class="btn">Mitglieder bearbeiten</button>
            </div>

          </div>
        </li>
      </ul>
    </div>


    <div class="form-horizontal max-w-2xl">
      <p class="font-bold">Deine Quizeinstellungen</p>

      <div class="form-group">
        <label class="form-label col-4" for="timer-duration">Timerdauer in Sekunden</label>
        <input id="timer-duration" :value="settings.timerDuration" class="form-input col-8"
               placeholder="Standard Timerdauer" type="number"
               @change="updateSetting({timerDuration: parseInt($event.target.value) || 30})">
      </div>

      <div class="form-group">
        <label class="form-label col-4" for="timer-sound">Timersound</label>
        <div class="col-8">
          <audio v-if="settings.timerSound && timerSoundPath" :src="timerSoundPath.url" class="max-h-full"
                 controls></audio>
          <button v-else id="timer-sound" class="btn btn-primary" @click="selectMedia">Sound wählen</button>
          <button v-if="settings.timerSound" class="btn btn-link ml-2" @click="updateSetting({timerSound: null})">
            Sound löschen
          </button>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { globalSettingsDoc } from "@/plugins/firebase";
import { injectComponentWithReturn } from "@/main";
import SelectMediaPopup from "../SelectMediaPopup";

export default {
  methods: {
    updateSetting(update) {
      globalSettingsDoc.update(update);
    },
    selectMedia() {
      injectComponentWithReturn(SelectMediaPopup, { audio: true }).then(media => {
        this.updateSetting({ timerSound: media });
      });
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    },
    user() {
      return this.$store.state.user;
    },
    timerSoundPath() {
      return this.$store.state.media.mediaFiles.find(m => m.ref.fullPath.includes(this.settings.timerSound));
    },
  }
}
</script>